export const SHORTENED_ENTRY_TYPE_LENGTH = 20;
export const SHORTENED_CONTRACT_NAME_LENGTH = 20;
export const SHORT_CONTRACT_NAME_LENGTH = 45;
export const SHORTENED_UREF_KEY_LENGTH = 30;
export const SHORTENED_CONTRACT_DESCRIPTION_LENGTH_MOBILE = 150;
export const SHORTENED_CONTRACT_DESCRIPTION_LENGTH_DESKTOP = 300;

export const truncateName = (name, limit) =>
  name && name.length > limit ? name.substring(0, limit - 1) + '...' : name;
